// This is being used for the flash messages in the application, to auto-hide them after 5 seconds
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Auto-hide flash messages after 5 seconds
    setTimeout(() => {
      this.element.classList.add('opacity-0', 'transition-opacity', 'duration-500')
      setTimeout(() => {
        this.element.remove()
      }, 500)
    }, 5000)
  }
} 